import React, { Suspense } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  Redirect
} from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import {connect } from "react-redux";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";

function Property_owner_new_registration1(props) {
  const {frontLabelsName} = props.label;
  const { isAuthenticated, loading } = props.auth;
  
  if (isAuthenticated && !loading) {
    return <Redirect to="/already-sign-in" />;
  }
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-5 pt-5">
        <div className="main-rg-new-box">
          <div className="login-box-rg-new">
            <div className="row">
              <Form className="pt-5">
                <div className="text-center">
                  <h2 className="set-font-size">
                  {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_new_registration")
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_new_registration"
                    )[0]["value"] || "lbl_new_registration"
                  : "lbl_new_registration"
                : "lbl_new_registration"}
                  </h2>
                </div>
                <div className="set-pdd mb-3">
                  <div className="el-and-login w-100">
                    <Link to="/dashboard">
                      <button className="el-one-new-rg">
                        
                        {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_registration_with_electronic")
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_registration_with_electronic"
                    )[0]["value"] || "lbl_registration_with_electronic"
                  : "lbl_registration_with_electronic"
                : "lbl_registration_with_electronic"}
                      </button>
                    </Link>
                  </div>
                  <div className="button-set">
                    <Link to="/access-by-otp">
                      <Button>
                      {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_registration_with_otp")
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_registration_with_otp"
                    )[0]["value"] || "lbl_registration_with_otp"
                  : "lbl_registration_with_otp"
                : "lbl_registration_with_otp"}
                      </Button>
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}
const mapStateToProps=(state)=>({
  label:state.language,
  auth:state.auth,
})
export default connect(mapStateToProps,{})(Property_owner_new_registration1);
